/**
 * Build a login page URL that returns the user to `returnUrl` after sign-in.
 * Pairs with LoginPageController's returnUrl handling (GET query + POST hidden field).
 */
const buildLoginRedirectUrl = (returnUrl) => {
  const destination = (returnUrl || '').trim();
  if (!destination) {
    return (window.loginUrl || '/login').trim();
  }

  const loginUrl = (window.loginUrl || '/login').trim();
  const separator = loginUrl.indexOf('?') >= 0 ? '&' : '?';
  return `${loginUrl}${separator}returnUrl=${encodeURIComponent(destination)}`;
};

const redirectToLogin = (returnUrl) => {
  window.location.href = buildLoginRedirectUrl(returnUrl);
};

export {
  buildLoginRedirectUrl,
  redirectToLogin,
};
